module.exports = __webpack_public_path__ + "img/GW.6a5a27ff.png";